import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'Ad2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ad-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11.933 5h-6.933v16h13v-8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 17h-5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 13h5v-4h-5z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 5v-2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 6l2 -2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19 9h2"
    }, null), _createTextVNode(" ")]);
  }
};